import { ReduxPageType } from '@common-types/ReduxPage';
import { Stack } from '@common/components/Stack';
import { useLabels } from '@features/Menu/useLabels';
import { TranslationKey, useTranslations } from '@lang';
import { entitySelectors } from '@store/entity/selectors';
import { some } from '@utils/some';
import { connect } from 'react-redux';
import { Link } from 'shared-routing';
import { mapModules } from '../BasketDrawer.helpers';
import { ItemText, StyledImg, StyledRecommendationButton } from '../BasketDrawer.styles';
import {
  RecommendationBox,
  RecommendationsContainer,
  TextAndButtonBox,
} from './Recommendations.styles';

type ReduxProps = {
  spaPage: ReduxPageType;
  tablesPage: ReduxPageType;
  roomsPage: ReduxPageType;
  golfPage: ReduxPageType;
};

type ReccomendationsProps = {
  modules: string[];
};

const slugToLabelKey: Record<string, string> = {
  rooms: 'rooms',
  dining: 'tables',
  spa: 'spa',
};

const RecommendationsList = ({
  modules,
  spaPage,
  tablesPage,
  roomsPage,
  golfPage,
}: ReccomendationsProps & ReduxProps) => {
  const { t } = useTranslations();
  const labels = useLabels();

  const mappedModules = mapModules(modules, { spaPage, tablesPage, roomsPage, golfPage });

  return (
    <RecommendationBox>
      <Stack gap={2} justifyContent="flex-start">
        {some(mappedModules)
          ? mappedModules.map((module) => (
              <RecommendationsContainer key={module?.id}>
                {module?.heroBackgroundImage && (
                  <StyledImg height={100} width={100} src={module.heroBackgroundImage.url} />
                )}
                <TextAndButtonBox>
                  <ItemText>
                    {((module?.slug && labels?.[slugToLabelKey[module.slug]]) ||
                      t(`basketDrawer.${module?.slug}` as TranslationKey)) ??
                      t('basketDrawer.recommendations.fallback')}
                  </ItemText>
                  <Link route={module?.route ?? ''}>
                    <StyledRecommendationButton isPrimary isNarrow isSmall>
                      {t('common.view.plain')}
                    </StyledRecommendationButton>
                  </Link>
                </TextAndButtonBox>
              </RecommendationsContainer>
            ))
          : null}
      </Stack>
    </RecommendationBox>
  );
};

const mapStateToProps = (state) => ({
  spaPage: entitySelectors.getSpaPage(state),
  tablesPage: entitySelectors.getTablesPage(state),
  roomsPage: entitySelectors.getPage(state, 'rooms'),
  golfPage: entitySelectors.getPage(state, 'golf'),
});

export const Recommendations = connect(mapStateToProps)(RecommendationsList);
